import { ConnectionProvider, WalletProvider } from '@solana/wallet-adapter-react';
import { WalletModalProvider } from '@solana/wallet-adapter-react-ui';
import { UserProvider } from './user.context';
import { StoreProvider } from './store.context';
import { OrderProvider } from './order.context';

const wallets: any = [];

export function AppProviders(props: { children: React.ReactNode }) {
   return (
      <>
         {process.env.REACT_APP_RPC ? (
            <ConnectionProvider
               endpoint={process.env.REACT_APP_RPC!}
               config={{ confirmTransactionInitialTimeout: 60000 }}>
               <WalletProvider
                  wallets={wallets}
                  autoConnect={true}>
                  <WalletModalProvider>
                     <UserProvider>
                        <StoreProvider>
                           <OrderProvider>{props.children}</OrderProvider>
                        </StoreProvider>
                     </UserProvider>
                  </WalletModalProvider>
               </WalletProvider>
            </ConnectionProvider>
         ) : (
            <div className="flex justify-center w-100 h-100vh items-center">
               <h1>Missing environement variables</h1>
            </div>
         )}
      </>
   );
}
